module.exports = __webpack_public_path__ + "img/brand_icon04.11930be.1077ec41.png";